import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KpiGrid, StatusChip } from "@/components/kcc/Kpi";
import { Panel, ModuleHeader } from "@/components/kcc/Panel";
import { DataTable, statusToChip } from "@/components/kcc/DataTable";

export default function Asset360() {
    const [data, setData] = useState(null);
    const [q, setQ] = useState("");
    useEffect(() => { api.get("/assets/register").then(({ data }) => setData(data)); }, []);
    const rows = (data?.assets || []).filter((a) => {
        const s = (q || "").toLowerCase();
        if (!s) return true;
        return a.asset_tag.toLowerCase().includes(s) || a.name.toLowerCase().includes(s) || a.location.toLowerCase().includes(s) || a.manufacturer.toLowerCase().includes(s);
    });
    return (
        <div className="space-y-6">
            <ModuleHeader kicker="Asset360" title="Digital Asset Passports" description="Every critical asset has a QR-linked passport — hierarchy, drawings, manuals, history, condition and remaining life." />
            <KpiGrid kpis={data?.kpis || []} accent="cobalt" cols={4} />
            <Panel
                title="Asset Register"
                accent="cobalt"
                actions={
                    <input
                        placeholder="Search asset tag, name, location…"
                        value={q}
                        onChange={(e) => setQ(e.target.value)}
                        className="bg-white/[0.03] border border-white/10 rounded-md px-3 py-1.5 text-xs w-72 outline-none focus:border-kcc-cobalt/50"
                        data-testid="asset-search"
                    />
                }
            >
                <DataTable
                    columns={[
                        { key: "asset_tag", label: "Tag" },
                        { key: "name", label: "Asset" },
                        { key: "family", label: "Family" },
                        { key: "criticality", label: "Crit.", render: (r) => <span className={`font-mono-kcc text-xs ${r.criticality === "A" ? "text-kcc-red" : r.criticality === "B" ? "text-kcc-amber" : "kcc-text-silver"}`}>{r.criticality}</span> },
                        { key: "location", label: "Location" },
                        { key: "manufacturer", label: "OEM" },
                        { key: "commissioned", label: "Comm." },
                        { key: "availability_pct", label: "Avail", render: (r) => `${r.availability_pct}%` },
                        { key: "condition", label: "Condition", render: (r) => <StatusChip status={statusToChip(r.condition)}>{r.condition}</StatusChip> },
                        { key: "risk_score", label: "Risk" },
                    ]}
                    rows={rows.slice(0, 60)}
                    testid="asset-table"
                />
            </Panel>
        </div>
    );
}
